import React from 'react';
import SEO from '../components/SEO';
import '../styles.css';

function CareersPage() {
  return (
    <div className="page-container">
      <SEO
        title="Careers at Virgil"
        description="Virgil does not currently have open roles."
        noindex
      />
      <section className="content-section static-page-section careers-page-section">
        <h1 className="page-title page-title--wide">Careers at Virgil</h1>
        <p className="page-lead page-lead--compact">
          Help us build the writing tools we want to use ourselves.
        </p>

        <div className="page-content page-content--polished">
          <div className="static-panel-grid">
            <article className="static-panel">
              <p className="static-panel-kicker">Why Work With Us</p>
              <h2>Small team, ambitious product</h2>
              <p>
                We care about writers. We build tools that use the best of AI without losing respect for the craft of storytelling.
              </p>
            </article>

            <article className="static-panel">
              <p className="static-panel-kicker">Current Openings</p>
              <h2>Quiet for now, growing soon</h2>
              <p>
                We do not have open roles right now. Check back here for future openings.
              </p>
            </article>
          </div>

          <article className="static-panel static-panel--wide">
            <p className="static-panel-kicker">Get in Touch</p>
            <h2>Tell us what you'd want to build here</h2>
            <p>
              Interested in joining our team? Send your resume and a note about why you're excited about Virgil to <a href="mailto:haroldrosenthal@virgil.com.ai">haroldrosenthal@virgil.com.ai</a>.
            </p>
          </article>
        </div>
      </section>
    </div>
  );
}

export default CareersPage;

